// extracted by mini-css-extract-plugin
export default {"root":"nl19ju","alert":"aYjBAX","mobile":"BXmn3w"};